<div class="rating" (mouseleave)="mouseleave()">
  <ng-container *ngFor="let ratingItem of ratings">
    <input type="radio" [name]="inputName" [value]="ratingItem.rating" [checked]="rating===ratingItem.rating" />
    <label [title]="ratingItem.tooltip" (click)='onClick(ratingItem)' (mouseenter)="mouseenter(ratingItem)">
      <i class="material-icons">grade</i>
    </label>
  </ng-container>
</div>
<div class="rating-text" [innerHTML]="(nextRating && nextRating.label) || (ratingModel && ratingModel.label) || ''"></div>
